import { useQueryClient } from 'react-query';
import {
  subscriptionApiKeys,
  useSubscriptionApi,
} from '@hooks/api/account/useSubscriptionApi';
import { usePostApi } from '@hooks/api/usePostApi';
import type { PostApiOptions } from 'types/api';

export function useAddPaymentMethod(
  organizationId: string,
  options?: Partial<PostApiOptions<void, string>>
) {
  const api = useSubscriptionApi();
  const queryClient = useQueryClient();

  const { post: addPaymentMethod, isPosting: isAddingPaymentMethod } =
    usePostApi({
      getSuccessMessage: () => 'Payment method added!',
      request: (params) => api.addPaymentMethod(organizationId, params),
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(
          subscriptionApiKeys.getPaymentMethods(organizationId)
        );
        options?.onSuccess?.(data, variables, context);
      },
    });

  return {
    addPaymentMethod,
    isAddingPaymentMethod,
  };
}
